<template>
    <mak-kontrol-planlama/>
</template>

<script>
    import MakKontrolPlanlama from '@/components/MakKontrolPlanlama.vue'

    export default {
        name: 'test-comp',
        components: { MakKontrolPlanlama },
    }
</script>
